export const ATTENDING = "attending";
export const MAYBE = "maybe";
export const NOT_ATTENDING = "notAttending";
export const AWAITING_REPLY = "awaitingReply";
export const SENT = "sent";
export const UNSENT = "unsent";

export const ATTENDING_STATUS_LABEL = {
  [ATTENDING]: "Attending",
  [AWAITING_REPLY]: "Awaiting Reply",
  [MAYBE]: "Maybe",
  [NOT_ATTENDING]: "Not Attending",
  [SENT]: "Sent Invitation",
  [UNSENT]: "Unsent Invitation",
};

export const COLLECTION_FORM_SOURCE = "collection-form";
